import { SubscribeToNewsletterInput } from "~/types/newsletter/newsletter.types";

import { sendRequest } from "../clients/axios";

export const subscribeToNewsletter = async (
  input: SubscribeToNewsletterInput
) => {
  await sendRequest<SubscribeToNewsletterInput, never>({
    method: "post",
    url: "/newsletter/subscribe/",
    data: input,
  });
};
